<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert type="error" v-show="erro">
      {{ mensagemErro }}
    </v-alert>

    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="green accent-4"
      dark
      @click="fecharNotificacao"
    >
      {{ newNotify.text }}
    </v-alert>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Funcionarios/Usuários'"
      :newRowmodalButtonText="'Novo funcionario/usuário'"
      :tableHeader="headers"
      :tableRows="funcionario"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <FormModal
      :isTheModalOpen="formModalData.isOpen"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isLoadingRequestDisable="formModalData.isLoadingRequestDisable"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-col cols="12">
        <v-alert
          transition="scale-transition"
          type="error"
          text
          hide-details="auto"
          v-show="mensagemModal.erro"
          >{{ mensagemModal.text }}</v-alert
        >
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.nomeFuncionario"
          name="nomeFuncionario"
          label="Nome do Funcionario"
          :rules="[limitCharacters]"
          counter="255"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.descricaoCpf"
          v-mask="['###.###.###-##', '##.###.###/####-##']"
          name="descricaoCpf"
          label="CPF"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.descricaoTelefone"
          v-mask="['(##)#####-####']"
          name="descricaoTelefone"
          label="Telefone ou celular"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="validateEmail"
          name="descricaoEmail"
          type="email"
          label="Email"
          :rules="rules"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="formModalData.actualEdit.descricaoSenha"
          name="descricaoSenha"
          label="Senha"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-select
          label="Cargo"
          item-text="nomeCargo"
          item-value="nomeCargo"
          :items="cargo"
          v-model="formModalData.actualEdit.descricaoCargo"
        >
        </v-select>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          label="Unidade"
          item-text="nomeEndereco"
          item-value="numeroEnderecoOrdemServico"
          :items="endereco"
          v-model="formModalData.actualEdit.numeroEnderecoOrdemServico"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        <v-select
          label="Nivel de Acesso"
          item-text="nomeIndicadorNivelAcesso"
          item-value="indicadorNivelAcesso"
          :items="nivelDeAcesso"
          v-model="formModalData.actualEdit.indicadorNivelAcesso"
        >
        </v-select>
      </v-col>
    </FormModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "@/components/DataTable2.vue";
import FormModal from "@/components/FormModal.vue";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import SkeletonTable from "../components/SkeletonTable";

export default {
  components: {
    DataTable,
    FormModal,
    Loading,
    SkeletonTable,
  },

  data: () => ({
    newNotify: {
      isNewNotify: false,
      text: "",
    },

    erro: false,
    mensagemErro: "Erro",
    mensagemModal: {
      erro: false,
      text: null,
    },

    showSkeletonTable: true,
    loading: false,
    validateEmail: null,
    emailInicial: null,
  

    limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.',
    rules: [
      value => !!value || 'Campo obrigatorio.',
      value => (value || '').length <= 30 || 'Max 30 characteres',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'E-mail invalido.'
      },
    ],

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroFuncionario",
      },
      {
        text: "Nome",
        value: "nomeFuncionario",
      },
      {
        text: "CPF",
        value: "descricaoCpf",
      },
      {
        text: "E-mail",
        value: "descricaoEmail",
      },
      {
        text: "Cargo",
        value: "descricaoCargo",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    formModalData: {
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroFuncionario: null,
        nomeFuncionario: null,
        descricaoCpf: null,
        descricaoTelefone: null,
        descricaoEmail: null,
        descricaoSenha: null,
        descricaoCargo: "Funcionario",
        indicadorNivelAcesso: 1,
        numeroEnderecoOrdemServico: null,
        descricaoTela: "funcionario",
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //Array populado pela função initialize
    funcionario: [],
    endereco: [],
    nivelDeAcesso: [],
    cargo: [],
  }),

  created() {
    this.initialize();
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    onDataTableUpdateRow(item) {
      this.loading = true
      this.formModalData.isOpen = true;
      this.formModalData.isEdit = true;
      this.formModalData.buttonText = "Concluir";
      this.formModalData.formTitle = "Atualizar Funcionario/Usuario";

      this.formModalData.actualEdit.numeroFuncionario = item.numeroFuncionario;
      this.formModalData.actualEdit.nomeFuncionario = item.nomeFuncionario;
      this.formModalData.actualEdit.descricaoCpf = item.descricaoCpf;
      this.formModalData.actualEdit.descricaoTelefone = item.descricaoTelefone;
      this.formModalData.actualEdit.descricaoEmail = item.descricaoEmail;
      this.validateEmail = item.descricaoEmail;
      this.emailInicial = item.descricaoEmail;
      this.formModalData.actualEdit.descricaoSenha = item.descricaoSenha;
      this.formModalData.actualEdit.descricaoCargo = item.descricaoCargo;
      this.formModalData.actualEdit.indicadorNivelAcesso = item.indicadorNivelAcesso;
      this.formModalData.actualEdit.numeroEnderecoOrdemServico = item.numeroEnderecoOrdemServico;
      this.loading = false
    },

    onDataTableInsertRow() {
      this.loading = true
      this.formModalData.isOpen = true;
      this.formModalData.isEdit = false;
      this.formModalData.buttonText = "Concluir";
      this.formModalData.formTitle = "Novo Funcionario/Usuario";

      this.formModalData.actualEdit.numeroFuncionario = null;
      this.formModalData.actualEdit.nomeFuncionario = null;
      this.formModalData.actualEdit.descricaoCpf = null;
      this.formModalData.actualEdit.descricaoTelefone = null;
      this.formModalData.actualEdit.descricaoEmail = null;
      this.formModalData.actualEdit.descricaoSenha = null;
      this.formModalData.actualEdit.descricaoCargo = "Funcionario";
      this.formModalData.actualEdit.indicadorNivelAcesso = null;
      this.formModalData.actualEdit.numeroEnderecoOrdemServico = null;
      this.validateEmail = null;
      this.isOpenEdit = false;
      this.loading = false
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.deleteItem(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._recoverFuncionario();
      }
    },

    async onFormModalAction() {
      try {
        this.formModalData.isButtonsDisabled = true;
        if (this.formModalData.isEdit) {
          await this.update(this.formModalData.actualEdit);
        } else {
          await this.insert(this.formModalData.actualEdit);
        }
      } catch (error) {
        this.mensagemErro = error.response.data.message;
      } finally {
        await this._recoverFuncionario();
        this.formModalData.isButtonsDisabled = false;
        this.formModalData.isOpen = false;
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    async _recoverEndereco() {
      const responseEndereco = await axios.get("enderecoordemservico", this.config);

      this.endereco = responseEndereco.data.concat([
        {
          nomeEndereco: "O funcionario não possui UBS.",
          numeroEnderecoOrdemServico: null,
        },
      ]);
    },

    async validateIfEmailExists() {
      try {
        let validate = await axios.post("/emailValidate", this.formModalData.actualEdit, this.config );

        if (validate.data) {
          this.mensagemModal.erro = true;
          this.mensagemModal.text =
            "O email inserido já está cadastrado no nosso banco de dados";
        } else {
          this.mensagemModal.erro = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async _recoverFuncionario() {
      try {
        const responseFuncionario = await axios.get("funcionario", this.config);
        this.showSkeletonTable = false;
        this.funcionario = responseFuncionario.data;
      } catch (error) {
        console.log(error);
      }
    },

    async _recoverNivelDeAcesso() {
      const nivelDeAcessoList = [
        {
          indicadorNivelAcesso: 1,
          nomeIndicadorNivelAcesso: "Administrador",
        },
        {
          indicadorNivelAcesso: 2,
          nomeIndicadorNivelAcesso: "Gestor de Unidade",
        },
        {
          indicadorNivelAcesso: 3,
          nomeIndicadorNivelAcesso: "Coordenação Odonto",
        },
      ];
      this.nivelDeAcesso = nivelDeAcessoList;
    },

    async _recoverCargos() {
      const cargo = [
        {
          nomeCargo: "Geral",
        },
      ];
      this.cargo = cargo;
    },

    async initialize() {
      try {
        await this._recoverFuncionario();
        await this._recoverNivelDeAcesso();
        await this._recoverEndereco();
        await this._recoverCargos();
      } catch (error) {
        console.log(error);
      }
    },

    async insert(reciveItem) {
      try {
        this.formModalData.isLoadingRequestDisable = true;
        await axios.post("funcionario", reciveItem, this.config);

        
        this.erro = false;
        
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      } finally {
        this.formModalData.isLoadingRequestDisable = false;
      }
    },

    async update(reciveItem) {
      try {
        this.formModalData.isLoadingRequestDisable = true;
        await axios.put("funcionario", reciveItem, this.config);
       
        this.erro = false;
        
        return true;
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      } finally {
        this.formModalData.isLoadingRequestDisable = false;
      }
    },

    async deleteItem(reciveItem) {
      try {
        if (confirm("Você realmente deseja excluir este funcionario?")) {
          this.formModalData.isLoadingRequestDisable = true;
          reciveItem.descricaoTela = "funcionario";

          await axios.delete("funcionario", {
            data: reciveItem,
            headers: this.config.headers,
          });
          
          this.erro = false;
          
          return true;
        }
      } catch (error) {
        this.mensagemErro = error.response.data.message;
        this.erro = true;
      } finally {
        this.formModalData.isLoadingRequestDisable = false;
        this.initialize();
      }
    },
  },

  watch: {
    validateEmail() {
      if(this.emailInicial != this.validateEmail ){
        if (this.formModalData.actualEdit.descricaoEmail != null && this.formModalData.actualEdit.descricaoEmail) {
          this.formModalData.actualEdit.descricaoEmail = this.validateEmail;
          this.formModalData.isButtonsDisabled = false;
          this.validateIfEmailExists();
          if(this.validateEmail == '' || this.validateEmail == null) {
            this.formModalData.isButtonsDisabled = true;
          }
        } else {
          this.formModalData.actualEdit.descricaoEmail = this.validateEmail;
          this.formModalData.isButtonsDisabled = true;
          this.validateIfEmailExists();
        }
      }
    },
  },
};
</script>